module.exports = __webpack_public_path__ + "img/login-background.580b53bc.jpg";